(() => {
  const PRODUCT_HANDLE = 'simagic-zeus-formula-steering-wheel';
  const DETAIL_HANDLE = 'airlink-wireless-hotspot';
  const BUNDLE_VARIANT_IDS = {
    wheelWithScreen: 57968882352431,
    wheelWithScreenAndMaglinkProAlpha: 57969029120303,
    wheelWithScreenAndMaglinkProOther: 58005533786415,
    wheelWithScreenAndAirlink: 57969017061679,
    wheelWithMaglinkProAlpha: 57997634568495,
    wheelWithMaglinkProOther: 58005619015983
  };

  console.log('3D Configurator Powered by GizmoTech [https://gizmotech.cn]');

  function getTargetOrigin(iframe) {
    try {
      return new URL(iframe.src, window.location.href).origin;
    } catch (e) {
      return '*';
    }
  }

  function getInitData(root) {
    const script = root.querySelector('[data-zeus-init-data]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeLocale(locale) {
    if (!locale) return 'en-US';

    return locale.toLowerCase().startsWith('zh') ? 'zh-CN' : 'en-US';
  }

  function getCurrentLocale(root) {
    return normalizeLocale(document.documentElement.lang || getInitData(root)?.locale);
  }

  function postInitData(root, iframe) {
    const payload = getInitData(root);
    if (!payload || !iframe.contentWindow) return;

    iframe.contentWindow.postMessage(
      {
        type: 'INIT_DATA',
        payload: {
          ...payload,
          locale: getCurrentLocale(root)
        }
      },
      getTargetOrigin(iframe)
    );
  }

  function getShopDomain(root) {
    return root.dataset.shopDomain || 'https://8c9752.myshopify.com';
  }

  // Read the storefront origin injected by Liquid so preview/theme-editor pages
  // can still navigate against the storefront domain instead of admin.shopify.com.
  function getStorefrontOriginFromRoot(root) {
    return root.dataset.storefrontOrigin || '';
  }

  // Resolve the safest storefront origin for the current environment:
  // 1. prefer the Liquid-provided storefront origin
  // 2. fall back to the shop domain in localhost/theme-editor
  // 3. otherwise use the current page origin on the live storefront
  function getStorefrontOrigin(root) {
    const isLocalhost =
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === 'localhost';
    const isThemeEditor = window.location.hostname === 'admin.shopify.com';
    const storefrontOrigin = getStorefrontOriginFromRoot(root);

    if (storefrontOrigin) return storefrontOrigin;
    if (isLocalhost || isThemeEditor) return getShopDomain(root);

    return window.location.origin;
  }

  function getProductUrl(root) {
    const storefrontOrigin = getStorefrontOrigin(root);
    const url = new URL(`${window.Shopify?.routes?.root || '/'}products/${PRODUCT_HANDLE}`, storefrontOrigin);
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

    if (previewThemeId) {
      url.searchParams.set('preview_theme_id', previewThemeId);
    }

    return url.toString();
  }

  function getHomeUrl(root) {
    const storefrontOrigin = getStorefrontOrigin(root);
    const url = new URL(`${window.Shopify?.routes?.root || '/'}pages/detail-simagic-zeus-formula-steering-wheel`, storefrontOrigin);
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

    if (previewThemeId) {
      url.searchParams.set('preview_theme_id', previewThemeId);
    }

    return url.toString();
  }

  function getPreviewThemeId() {
    return new URLSearchParams(window.location.search).get('preview_theme_id');
  }

  function appendPreviewThemeId(url) {
    const previewThemeId = getPreviewThemeId();

    if (previewThemeId) {
      url.searchParams.set('preview_theme_id', previewThemeId);
    }

    return url;
  }

  function getCartUrl(root) {
    return appendPreviewThemeId(new URL(`${window.Shopify?.routes?.root || '/'}cart`, getStorefrontOrigin(root))).toString();
  }

  function getCheckoutUrl(root) {
    return appendPreviewThemeId(new URL(`${window.Shopify?.routes?.root || '/'}checkout`, getStorefrontOrigin(root))).toString();
  }

  function getDetailUrl(root, productHandle = DETAIL_HANDLE) {
    return appendPreviewThemeId(new URL(`${window.Shopify?.routes?.root || '/'}products/${productHandle || DETAIL_HANDLE}`, getStorefrontOrigin(root))).toString();
  }

  function getDetailTarget(root, payload = {}) {
    if (payload.detailUrl) {
      try {
        return appendPreviewThemeId(new URL(payload.detailUrl, getStorefrontOrigin(root))).toString();
      } catch (e) {
        return payload.detailUrl;
      }
    }

    return getDetailUrl(root, payload.productHandle);
  }

  function buildBundleItemIds(payload = {}) {
    const wheelVariantId = payload.wheelVariantId || null;
    const screenVariantId = payload.screenVariantId || null;
    const paddleVariantId = payload.paddleVariantId || null;
    const linkVariantId = payload.linkVariantId || null;
    const linkHandle = payload.linkHandle || null;
    const wheelBase = payload.wheelBase || null;
    const hasScreen = Boolean(screenVariantId);
    const isMaglinkPro = linkHandle === 'maglink-pro';
    const isMaglinkProXtend = linkHandle === 'maglink-pro-xtend';
    const isAirlink = linkHandle === 'airlink-wireless-hotspot';
    const isAlphaWheelBase = wheelBase === 'evo-series' || wheelBase === 'series';

    if (hasScreen && isMaglinkPro) {
      return [
        isAlphaWheelBase
          ? BUNDLE_VARIANT_IDS.wheelWithScreenAndMaglinkProAlpha
          : BUNDLE_VARIANT_IDS.wheelWithScreenAndMaglinkProOther,
        paddleVariantId
      ].filter(Boolean);
    }

    if (hasScreen && isAirlink) {
      return [BUNDLE_VARIANT_IDS.wheelWithScreenAndAirlink, paddleVariantId].filter(Boolean);
    }

    if (hasScreen && isMaglinkProXtend) {
      return [BUNDLE_VARIANT_IDS.wheelWithScreen, linkVariantId, paddleVariantId].filter(Boolean);
    }

    if (hasScreen && !linkHandle) {
      return [BUNDLE_VARIANT_IDS.wheelWithScreen, paddleVariantId].filter(Boolean);
    }

    if (!hasScreen && isMaglinkPro) {
      return [
        isAlphaWheelBase
          ? BUNDLE_VARIANT_IDS.wheelWithMaglinkProAlpha
          : BUNDLE_VARIANT_IDS.wheelWithMaglinkProOther,
        paddleVariantId
      ].filter(Boolean);
    }

    return [
      wheelVariantId,
      screenVariantId,
      linkVariantId,
      paddleVariantId
    ].filter(Boolean);
  }

  function getWheelBaseProperty(payload = {}) {
    const isZh = getCurrentLocale(document).toLowerCase().startsWith('zh');
    const labels = {
      'evo-series': isZh ? 'Alpha EVO系列' : 'Alpha EVO Series',
      series: isZh ? 'Alpha系列' : 'Alpha Series',
      third: isZh ? '第三方基座' : 'Third-Party',
      none: isZh ? '没有基座' : 'I Don\'t Have a Wheelbase'
    };
    const label = labels[payload.wheelBase];

    return label ? { 'Wheel Base': label } : null;
  }

  async function addItemsFromPayload(payload = {}) {
    const ids = buildBundleItemIds(payload);
    if (!ids.length) return false;
    const wheelBaseProperty = getWheelBaseProperty(payload);

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: ids.map((id, index) => ({
          id,
          quantity: 1,
          ...(index === 0 && wheelBaseProperty ? { properties: wheelBaseProperty } : {})
        }))
      })
    });

    return response.ok;
  }

  async function clearCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    });

    return response.ok;
  }

  function syncFullscreenMode(enabled) {
    document.body.classList.toggle('zeus-steering-wheel-fullscreen', enabled);
  }

  function initSection(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const iframe = root.querySelector('iframe');

    if (!iframe) return;

    const onLoad = () => {
      postInitData(root, iframe);
    };

    const onError = () => {
      root.classList.add('has-error');
    };

    const onMessage = (event) => {
      if (event.source !== iframe.contentWindow) return;
      if (event.origin !== getTargetOrigin(iframe)) return;
      if (!event.data) return;

      if (event.data.type === 'SIMAGIC_READY') {
        postInitData(root, iframe);
        return;
      }

      if (event.data.type === 'SIMAGIC_LAYOUT') {
        root.layoutState = event.data.payload || null;
        syncFullscreenMode(true);
        return;
      }

      if (event.data.type === 'REQUEST_GO_PRODUCT') {
        window.location.href = getProductUrl(root);
        return;
      }

      if (event.data.type === 'REQUEST_GO_HOME') {
        window.location.href = getHomeUrl(root);
        return;
      }

      if (event.data.type === 'REQUEST_OPEN_DETAIL') {
        window.open(getDetailTarget(root, event.data.payload || {}), '_blank', 'noopener');
        return;
      }

      if (event.data.type === 'REQUEST_GO_CART') {
        addItemsFromPayload(event.data.payload || {}).then((ok) => {
          if (ok) window.location.href = getCartUrl(root);
        });
        return;
      }

      if (event.data.type === 'REQUEST_GO_CHECKOUT') {
        addItemsFromPayload(event.data.payload || {}).then((ok) => {
          if (ok) window.location.href = getCheckoutUrl(root);
        });
      }
    };

    iframe.addEventListener('load', onLoad, { once: true });
    iframe.addEventListener('error', onError, { once: true });
    window.addEventListener('message', onMessage);

    root.resizeHandler = () => syncFullscreenMode(true);
    root.messageHandler = onMessage;
    window.addEventListener('resize', root.resizeHandler);
    syncFullscreenMode(true);

    root.dataset.initialized = 'true';
  }

  function destroySection(root) {
    if (root.resizeHandler) {
      window.removeEventListener('resize', root.resizeHandler);
      delete root.resizeHandler;
    }

    if (root.messageHandler) {
      window.removeEventListener('message', root.messageHandler);
      delete root.messageHandler;
    }

    syncFullscreenMode(false);
    delete root.dataset.initialized;
  }

  function init(container = document) {
    container.querySelectorAll('[data-zeus-steering-wheel]').forEach(initSection);
  }

  function destroy(container) {
    container.querySelectorAll('[data-zeus-steering-wheel]').forEach(destroySection);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  if (document.readyState !== 'loading') init();
})();
